import * as React from "react"

const SvgComponent = ({ width, height, ...props }) => (
<svg fill={props.color ? props.color : "#000"}
    width={width}
    height={height} 
    viewBox="0 0 32 32" 
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg">

    <path d="M27.297 11.119l-9.287 8.933v-5.412c-2.812 0-9.974 0.062-9.974 7.426 0 3.855 2.735 7.072 6.371 7.816-5.842-0.792-10.36-5.747-10.36-11.806 0-11.256 12.025-11.351 13.963-11.351v-4.607l9.287 9.001z">      
    </path>

</svg>
)

export default SvgComponent
